import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { GlobalTable, HeaderLine, Td, TdButtons, Th, Tr, FooterTr } from '../../../../components/styles/table-style'
import axios from '../../../../config/axios'
import { useNavigate, useOutletContext } from 'react-router-dom'
import lookup from '../../../../assets/certificates/Tables/lookup.svg'
import PricesDisplay from '../../../../components/PricesDisplay'
import LoadMoreButton from '../../../../components/LoadMoreButton'

const TableWrapper = styled.div`
  overflow-y: auto;
  overflow-x: auto;
  padding-right: 10px;

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 10px;
    border: 2px solid #c0c0c0;
  }
`

interface Service {
  id: number
  name: string
  code?: string
  category?: { id: number; name: string } | null
  type?: { id: number; name: string } | null
  pricePerHour?: number
  prices?: Array<{
    id: number
    price: string
    unitOfMeasurement: {
      id: number
      name: string
    }
  }>
  deadlineInDays?: number
}

const StageServicesTable:React.FC = () => {
  const { refresh, setIsLoading } = useOutletContext<any>()
  const [services, setServices] = useState<Service[]>([])
  const [visibleCount, setVisibleCount] = useState<number>(10)
  const [ totalServices, setTotalServices ] = useState<number | undefined>(undefined)
  const navigate = useNavigate()

  useEffect(() => {
    const getServices = async () => {
      if (setIsLoading) setIsLoading(true)
      try {
        const response = await axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/services/service-stage`, {
          params: {
            limit: visibleCount,
            offset: 0,
          }
        })
        if(response.data) setServices(response.data)
        if (setIsLoading) setIsLoading(false)
        try {
          const resp = await axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/services/service-stage/count`)
          if (resp && resp.data != null) {
            const value = typeof resp.data === 'number' ? resp.data : resp.data.totalItems ?? resp.data.total ?? undefined
            setTotalServices(value)
          }
        } catch (err) {
          setTotalServices(undefined)
        }
      } catch (error) {
        console.error(error)
        if (setIsLoading) setIsLoading(false)
      }
    }
    getServices()
  }, [visibleCount, refresh])

  const formatDeadline = (deadline?: number | null) => {
    if (!deadline) return 'N/A'
    return `${deadline} ${deadline === 1 ? 'dia útil' : 'dias úteis'}`
  }
  
  return (
    <TableWrapper>
      <GlobalTable>
      <thead>
        <HeaderLine>
          <Th>Serviço</Th>
          <Th>Categoria</Th>
          <Th>Tipo</Th>
          <Th>Código</Th>
          <Th>Preço</Th>
          <Th>Prazo</Th>
          <Th></Th>
        </HeaderLine>
      </thead>
      <tbody>
        {services.map((service, index) => (
          <Tr key={index}>
            <Td>{service.name}</Td>
            <Td>{service.category?.name || 'N/A'}</Td>
            <Td>{service.type?.name || 'N/A'}</Td>
            <Td>{service.code || 'N/A'}</Td>
            <Td>
              <PricesDisplay prices={service.prices || [] as any} maxWidth={200} />
            </Td>
            <Td>{formatDeadline(service.deadlineInDays)}</Td>
            <TdButtons>
              <img src={lookup} alt='looup-icon' onClick={() => navigate(`view/?id=${service.id}`)} />
            </TdButtons>
          </Tr>
        ))}
      </tbody>
      <tfoot>
        <FooterTr>
          <Td colSpan={7} style={{ textAlign: 'center', background: 'transparent' }}>
            <LoadMoreButton
              onLoadMore={() => setVisibleCount(prev => prev + 10)}
              hasMore={typeof totalServices === 'number' ? services.length < totalServices : false}
              currentCount={services.length}
              totalCount={totalServices}
            />
          </Td>
        </FooterTr>
      </tfoot>
    </GlobalTable>
    </TableWrapper>
    )
}

export default StageServicesTable
